var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5861 39.6C26.2928 39.6 24.3994 39.0133 22.9061 37.84C21.4261 36.6667 20.3728 35.08 19.7461 33.08L25.1061 31.8C25.2261 32.5333 25.6128 33.1733 26.2661 33.72C26.9194 34.2533 27.6128 34.52 28.3461 34.52C28.8528 34.52 29.3928 34.38 29.9661 34.1C30.5528 33.82 30.9728 33.3733 31.2261 32.76C31.3861 32.3733 31.4794 31.9 31.5061 31.34C31.5328 30.78 31.5461 30.1333 31.5461 29.4V10.2H37.0661V29.4C37.0661 30.32 37.0594 31.12 37.0461 31.8C37.0461 32.48 36.9794 33.12 36.8461 33.72C36.7261 34.3067 36.4794 34.92 36.1061 35.56C35.2928 36.9733 34.2328 38 32.9261 38.64C31.6194 39.28 30.1728 39.6 28.5861 39.6Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.75 60C42.8745 60 30 72.8745 30 75.75C30 72.8745 17.1255 60 14.25 60C17.1255 60 30 47.1255 30 44.25C30 47.1255 42.8745 60 45.75 60Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJd);
export default __webpack_public_path__ + "static/media/jd.d59409bd5fa2601664737326dca0c5ed.svg";
export { ForwardRef as ReactComponent };